import CloutChaseIcon from './clout-chase.svg';
import HanaIcon from './hana.svg';
import ImagineIcon from './imagine.svg';
import MangaIcon from './manga.svg';
import McIcon from './mc.svg';
import PersonaIcon from './persona.svg';
import ProgramIcon from './program.svg';
import RecordsIcon from './records.svg';
import StudioIcon from './studio.svg';
import UnaIcon from './una.svg';

export {
  PersonaIcon,
  McIcon,
  UnaIcon,
  MangaIcon,
  StudioIcon,
  CloutChaseIcon,
  HanaIcon,
  ProgramIcon,
  RecordsIcon,
  ImagineIcon,
};
